export enum VertiType {
	Flex = "Flex",
	Node = "Node",
}
